import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { _T } from "../src/Localization";
const dateFormat = 'YYYY-MM-DD';
export function useSchedulePages(event_id, schedule) {
    const [pages, setPages] = useState([]);
    const [pageData, setPageData] = useState([[]]);
    const [defaultPageId, setDefaultPageId] = useState();
    useEffect(() => {
        if (schedule) {
            const _pages = [];
            const _pageData = [];
            const initialItems = [];
            const userPages = [];
            const userPageData = [];
            let currentItems = [];
            schedule.forEach((item) => {
                if (item.schedule_type === 'break') {
                    if (userPages.length === 0) {
                        if (currentItems.length > 0) {
                            initialItems.push(...currentItems);
                        }
                    }
                    else {
                        userPageData.push(currentItems);
                    }
                    userPages.push(item);
                    currentItems = [];
                }
                else {
                    currentItems.push(item);
                }
            });
            if (userPages.length === 0) {
                if (currentItems.length > 0) {
                    initialItems.push(...currentItems);
                }
            }
            else {
                userPageData.push(currentItems);
            }
            if (initialItems.length > 0) {
                _pages.push({
                    schedule_value: _T('schedule.page.initial'),
                    schedule_type: 'break',
                    schedule_id: 'initial'
                });
                _pageData.push(initialItems);
            }
            _pages.push(...userPages);
            _pageData.push(...userPageData);
            // Page with unassigned schedule rounds
            _pages.push({
                schedule_value: _T('schedule.page.unassigned'),
                schedule_type: 'break',
                schedule_id: 'unassigned'
            });
            _pageData.push([
                {
                    schedule_value: _T('schedule.page.unassigned'),
                    schedule_id: 'null'
                }
            ]);
            setPages(_pages);
            setPageData(_pageData);
        }
    }, [schedule]);
    useEffect(() => {
        if (pages.length > 0) {
            const nonUnassignedPages = pages.filter((page) => String(page.schedule_id) !== 'unassigned');
            let newPageId = nonUnassignedPages.length > 0
                ? nonUnassignedPages[0].schedule_id
                : pages[0].schedule_id;
            if (nonUnassignedPages.length > 1 &&
                String(nonUnassignedPages[0].schedule_id) === 'initial') {
                newPageId = nonUnassignedPages[1].schedule_id;
            }
            const userMoment = dayjs();
            nonUnassignedPages.forEach((page) => {
                if (page.schedule_date) {
                    const pageMoment = dayjs(page.schedule_date, dateFormat);
                    if (userMoment.isSame(pageMoment, 'day')) {
                        newPageId = page.schedule_id;
                    }
                }
            });
            setDefaultPageId(newPageId);
        }
    }, [pages]);
    return { pages, pageData, defaultPageId };
}
export function getFormattedTime(value) {
    const timeFormat = 'HH:mm';
    if (value) {
        const time = dayjs(value, timeFormat);
        if (!time.isValid()) {
            return undefined;
        }
        return time.format(timeFormat);
    }
    else {
        return undefined;
    }
}
